

exports.__esModule = true;

var _angular = require('angular');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _addCard = require('../add-card');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('./init/directive');

require('./confirm/directive');

require('./styles');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _index = require('components/xo-models/src/checkout/index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoConfirmUpopDirective', {
    tag: 'xo-confirm-upop',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: true
        },
        phone: {
            type: 'var',
            required: false
        },
        cardmodel: {
            type: 'var',
            required: true
        },
        onSuccess: {
            type: 'var',
            required: false
        },
        onCancel: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.phone = this.props.phone || {};
            this.cardLast4 = this.cardmodel.card.number.slice(-4);
            this.fromLoginOverlay = _uiRouter.$stateParams.fromLoginOverlay;

            (0, _angular.$timeout)(function () {
                (0, _jquery2['default'])('#upopConfirmation .upopConfirm').addClass('upopOpen');
                if (_this.fromLoginOverlay) {
                    (0, _angular.$timeout)(function () {
                        (0, _jquery2['default'])('#upopConfirmation .modalWrapper').addClass('modalWrapperAnimation');
                    });
                }
            });

            var hideModal = function hideModal() {
                (0, _jquery2['default'])('#upopConfirmation .upopConfirm').removeClass('upopOpen');
            };

            var done = function done(handler, target) {
                hideModal();
                (0, _angular.$timeout)(function () {
                    return handler ? handler() : _this.goto(target);
                }, 300);
            };

            var _success = function _success() {
                done(_this.props.onSuccess, 'checkout.review');
            };

            this.closeModal = function (event) {
                if (event) {
                    event.preventDefault();
                }

                done(_this.props.onCancel, '^');
            };

            this.initSuccess = function () {
                _this.collectOtpInput = false;
            };

            this.confirmed = function () {
                if (_this.props.onSuccess) {
                    return _success();
                }

                _this.models.checkoutSession.fundingOptions.action('update', {
                    resultModel: _this.models.checkoutSession,
                    silent: true,
                    data: {
                        planId: _this.cardmodel.id
                    },
                    success: function success() {
                        if (_this.models.checkoutSession.cvvData) {
                            _this.models.checkoutSession.set('cvvData.security_code', _this.cardmodel.get('card.security_code'));
                        }
                        var isNewCard = !_this.cardmodel.card.isExisting();

                        var msg = isNewCard ? ['smallToolTip.cardAddedConfirmed'] : ['smallToolTip.cardConfirmed'];

                        _this.models.checkoutSession.message = {
                            type: 'success',
                            msgKeys: msg
                        };

                        _success();
                    },
                    contingencies: {
                        TRANSACTION_REFUSED: function TRANSACTION_REFUSED(name) {
                            _this.models.checkoutSession.message = {
                                type: 'info',
                                msgKeys: 'creditcard.addedButCannotUse'
                            };

                            _success();
                        }
                    }
                });
            };

            this.flag = function (field) {
                return _addCard.$CardMetaData.getMetaData(_this.cardmodel.card, field);
            };

            this.setMessage = function (message) {
                _this.message = message;
            };

            this.collectOtpInput = this.flag('fields.expiry') && !this.cardmodel.get('card.expiry_month') || this.flag('fields.cvv') && !this.cardmodel.get('card.expiry_month') || this.flag('fields.phone') && !(this.phone && this.phone.telephone);
        }
    }
});


_angular.$timeout;

_squid.$Component;

_uiRouter.$stateParams;

_addCard.$CardMetaData;

_index.$CheckoutSessionModel;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-wallet-components/src/confirm-upop/directive.js
 ** module id = 222
 ** module chunks = 1
 **/